// @ts-nocheck
import BookingAssistanceLink from "../../pages/booking-assistance/BookingAssistanceLink";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// import {  } from '../../store/';
import LogoutIcon from "../../assets/images/logout.svg";
import { alertDialogAciton, logoutAction } from "../../store/actions/auth";
import "./sidebar.css";
import { Button } from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { FRONTEND_CONFIG } from "../../utils/constants/configs";

const SidebarContractor = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const groupMessaging = useSelector((store) => store.groupMessaging);
  const oneOnOneMessaging = useSelector((store) => store.oneOnOneMessaging);

  // useEffect start...
  // React.useEffect(() => {
  //   if (!auth?.userToken) {
  //     navigate("/");
  //   }
  // }, [auth]);
  // useEffect end...

  return (
    <>
      {/* <Box sx={{width: '100px', minWidth: '100px'}}></Box> */}
      <Box className="sidebar-container">
        <Box className="top-routes">
          <BookingAssistanceLink />
          {/* Onboarding (2026-10-08): the checklist, always reachable. */}
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                "&.active": {
                  border: "1px solid #D175B6",
                  color: "#D175B6",
                },
              },
            }}
          >
            <Link
              to="/onboarding"
              className={location.pathname == "/onboarding" ? "active" : ""}
            >
              Onboarding
            </Link>
          </Box>
          {!auth?.disableDashboard && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: "16px 20px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                },
              }}
            >
              <Link
                to="/opportunities"
                className={
                  location.pathname == "/opportunities" ? "active" : ""
                }
              >
                Opportunities
              </Link>
            </Box>
          )}
          {/* {!auth?.disableDashboard ? ( */}
          {/*   <Accordion className="accordion"> */}
          {/*     <AccordionSummary */}
          {/*       expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />} */}
          {/*       aria-controls="panel1-content" */}
          {/*       id="panel1-header" */}
          {/*       className="accordion-summary" */}
          {/*       sx={{ */}
          {/*         "&.Mui-expanded": { */}
          {/*           border: "1px solid #D175B6", */}
          {/*           "& p": { */}
          {/*             color: "#D175B6", */}
          {/*           }, */}
          {/*           "& svg": { */}
          {/*             color: "#D175B6", */}
          {/*           }, */}
          {/*         }, */}
          {/*       }} */}
          {/*     > */}
          {/*       <Typography>Opportunities</Typography> */}
          {/*     </AccordionSummary> */}
          {/*     <AccordionDetails className="accordion-details"> */}
          {/*       <Box */}
          {/*         sx={{ */}
          {/*           "& a": { */}
          {/*             margin: "4px 0", */}
          {/*             width: "100%", */}
          {/*             color: "#ffffff", */}
          {/*             padding: "8px 14px", */}
          {/*             borderRadius: "4px", */}
          {/*             border: "1px solid transparent", */}
          {/*             position: "relative", */}
          {/*             "&:before": { */}
          {/*               content: '""', */}
          {/*               position: "absolute", */}
          {/*               width: "12px", */}
          {/*               height: "21px", */}
          {/*               borderRadius: "0 0 0 10px", */}
          {/*               borderBottom: "1px solid #ffffff", */}
          {/*               borderLeft: "1px solid #ffffff", */}
          {/*               left: "-13px", */}
          {/*               bottom: "13px", */}
          {/*             }, */}
          {/*             "& span": { */}
          {/*               height: "24px", */}
          {/*               width: "24px", */}
          {/*               background: "#FFF", */}
          {/*               color: "#D175B6", */}
          {/*               borderRadius: "100%", */}
          {/*               marginLeft: "5px", */}
          {/*               lineHeight: "24px", */}
          {/*               textAlign: "center", */}
          {/*               display: "inline-block", */}
          {/*               position: "absolute", */}
          {/*               right: "9px", */}
          {/*               top: "5px", */}
          {/*             }, */}
          {/*             "&.active": { */}
          {/*               color: "#D175B6", */}
          {/*               borderColor: "#D175B6", */}
          {/*               "&:before": { */}
          {/*                 borderBottom: "1px solid #D175B6", */}
          {/*                 borderLeft: "1px solid #D175B6", */}
          {/*                 zIndex: "1", */}
          {/*               }, */}
          {/*               "& span": { */}
          {/*                 background: "#D175B6", */}
          {/*                 color: "#fff", */}
          {/*               }, */}
          {/*             }, */}
          {/*           }, */}
          {/*           "& a + a:before": { */}
          {/*             height: "54px", */}
          {/*           }, */}
          {/*         }} */}
          {/*       > */}
          {/*         <Link */}
          {/*           to="/opportunities/not-responded" */}
          {/*           className={ */}
          {/*             location.pathname === "/opportunities/not-responded" */}
          {/*               ? "active" */}
          {/*               : "" */}
          {/*           } */}
          {/*         > */}
          {/*           Not Responded */}
          {/*         </Link> */}
          {/*         <Link */}
          {/*           to="/opportunities/applied" */}
          {/*           className={ */}
          {/*             location.pathname === "/opportunities/applied" */}
          {/*               ? "active" */}
          {/*               : "" */}
          {/*           } */}
          {/*         > */}
          {/*           Applied */}
          {/*         </Link> */}
          {/*       </Box> */}
          {/*     </AccordionDetails> */}
          {/*   </Accordion> */}
          {/* ) : null} */}

          {!auth?.disableDashboard ? (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: "16px 20px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                },
              }}
            >
              <Link
                to="/schedule"
                className={location.pathname == "/schedule" ? "active" : ""}
              >
                Schedule
              </Link>
            </Box>
          ) : null}

          {!auth?.disableDashboard && FRONTEND_CONFIG.contracts && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: "16px 20px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                },
              }}
            >
              <Link
                to="/contracts"
                className={
                  location.pathname == "/contracts" ||
                  location.pathname == "/contract-details"
                    ? "active"
                    : ""
                }
              >
                Contracts
              </Link>
            </Box>
          )}

          {/* <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                "&.active": {
                  border: "1px solid #D175B6",
                  color: "#D175B6",
                },
              },
            }}
          >
            <Link
              to="/notifications"
              className={location.pathname == "/notifications" ? "active" : ""}
            >
              Notifications
            </Link>
          </Box> */}

          {!auth?.disableDashboard ? (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: "16px 20px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                },
              }}
            >
              <Link
                to="/resources"
                className={location.pathname == "/resources" ? "active" : ""}
              >
                Resources
              </Link>
            </Box>
          ) : null}

          {/* <Box
                sx={{
                "& a": {
                    background: "transparent",
                    minHeight: "auto !important",
                    padding: "16px 20px",
                    color: "#ffffff",
                    fontSize: "20px",
                    border: "1px solid transparent",
                    borderRadius: "8px",
                    width: "100%",
                    "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                    },
                },
                }}
            >
                <Link
                    to="/logs-of-event"
                    className={location.pathname == "/logs-of-event" ? "active" : ""}
                >
                    Logs Of Request
                </Link>
            </Box> */}

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                "&.active": {
                  border: "1px solid #D175B6",
                  color: "#D175B6",
                },
              },
            }}
          >
            <Link
              to="/profile"
              className={location.pathname == "/profile" ? "active" : ""}
            >
              Profile
            </Link>
          </Box>

          {!auth?.disableDashboard ? (
            <Box>
              <Accordion className="accordion">
                <AccordionSummary
                  expandIcon={
                    <KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="accordion-summary"
                  sx={{
                    "&.Mui-expanded": {
                      border: "1px solid #D175B6",
                      "& p": {
                        color: "#D175B6",
                      },
                      "& svg": {
                        color: "#D175B6",
                      },
                    },
                  }}
                >
                  <Typography>Messages</Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ overflow: "hidden" }}
                  className="accordion-details"
                >
                  <Box
                    sx={{
                      "& a": {
                        margin: "4px 0",
                        width: "100%",
                        color: "#ffffff",
                        padding: "8px 14px",
                        borderRadius: "4px",
                        border: "1px solid transparent",
                        position: "relative",
                        "&:before": {
                          content: '""',
                          position: "absolute",
                          width: "12px",
                          height: "91px",
                          borderRadius: "0 0 0 10px",
                          borderBottom: "1px solid #ffffff",
                          borderLeft: "1px solid #ffffff",
                          left: "-13px",
                          bottom: "13px",
                        },
                        "& span": {
                          height: "24px",
                          width: "24px",
                          background: "#FFF",
                          color: "#D175B6",
                          borderRadius: "100%",
                          marginLeft: "5px",
                          lineHeight: "24px",
                          textAlign: "center",
                          display: "inline-block",
                          position: "absolute",
                          right: "9px",
                          top: "5px",
                        },
                        "&.active": {
                          color: "#D175B6",
                          borderColor: "#D175B6",
                          "&:before": {
                            borderBottom: "1px solid #D175B6",
                            borderLeft: "1px solid #D175B6",
                            zIndex: "1",
                          },
                          "& span": {
                            background: "#D175B6",
                            color: "#fff",
                          },
                        },
                      },
                      "& a + a:before": {
                        height: "954px",
                      },
                    }}
                  >
                    <Link
                      to="/event/chat"
                      className={
                        location.pathname === "/event/chat" ? "active" : ""
                      }
                    >
                      Event Chat
                      {groupMessaging?.unreadChatRoomsCount?.data?.groupCount >
                      0 ? (
                        <Typography
                          variant="span"
                          sx={{
                            background: `${getCssVariableHandler({
                              variableName: "--primary-pink-rgb",
                            })} !important`,
                            color: `${getCssVariableHandler({
                              variableName: "--font-rgb",
                            })} !important`,
                          }}
                        >
                          {
                            groupMessaging?.unreadChatRoomsCount?.data
                              ?.groupCount
                          }
                        </Typography>
                      ) : null}
                    </Link>
                    <Link
                      to="/event/chat/admin"
                      className={
                        location.pathname === "/event/chat/admin"
                          ? "active"
                          : ""
                      }
                    >
                      Admins
                      {oneOnOneMessaging?.unreadChatRoomsCount?.data
                        ?.oneOnOneCount > 0 ? (
                        <Typography
                          variant="span"
                          sx={{
                            background: `${getCssVariableHandler({
                              variableName: "--primary-pink-rgb",
                            })} !important`,
                            color: `${getCssVariableHandler({
                              variableName: "--font-rgb",
                            })} !important`,
                          }}
                        >
                          {
                            oneOnOneMessaging?.unreadChatRoomsCount?.data
                              ?.oneOnOneCount
                          }
                        </Typography>
                      ) : null}
                    </Link>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          ) : null}
          {!auth?.disableDashboard ? (
            <Box>
              <Accordion className="accordion">
                <AccordionSummary
                  expandIcon={
                    <KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="accordion-summary"
                  sx={{
                    "&.Mui-expanded": {
                      border: "1px solid #D175B6",
                      "& p": {
                        color: "#D175B6",
                      },
                      "& svg": {
                        color: "#D175B6",
                      },
                    },
                  }}
                >
                  <Typography>Training</Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ overflow: "hidden" }}
                  className="accordion-details"
                >
                  <Box
                    sx={{
                      "& a": {
                        margin: "4px 0",
                        width: "100%",
                        color: "#ffffff",
                        padding: "8px 14px",
                        borderRadius: "4px",
                        border: "1px solid transparent",
                        position: "relative",
                        "&:before": {
                          content: '""',
                          position: "absolute",
                          width: "12px",
                          height: "91px",
                          borderRadius: "0 0 0 10px",
                          borderBottom: "1px solid #ffffff",
                          borderLeft: "1px solid #ffffff",
                          left: "-13px",
                          bottom: "13px",
                        },
                        "& span": {
                          height: "24px",
                          width: "24px",
                          background: "#FFF",
                          color: "#D175B6",
                          borderRadius: "100%",
                          marginLeft: "5px",
                          lineHeight: "24px",
                          textAlign: "center",
                          display: "inline-block",
                          position: "absolute",
                          right: "9px",
                          top: "5px",
                        },
                        "&.active": {
                          color: "#D175B6",
                          borderColor: "#D175B6",
                          "&:before": {
                            borderBottom: "1px solid #D175B6",
                            borderLeft: "1px solid #D175B6",
                            zIndex: "1",
                          },
                          "& span": {
                            background: "#D175B6",
                            color: "#fff",
                          },
                        },
                      },
                      "& a + a:before": {
                        height: "954px",
                      },
                    }}
                  >
                    <Link
                      to="/safety-and-non-harassment-videos"
                      className={
                        location.pathname == "/safety-and-non-harassment-videos"
                          ? "active"
                          : ""
                      }
                    >
                      Safety and non-harassment videos
                    </Link>
                    <Link
                      to="/configuration/tutorial-video"
                      className={
                        location.pathname == "/configuration/tutorial-video"
                          ? "active"
                          : ""
                      }
                    >
                      Tutorial Video
                    </Link>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          ) : null}
          {!auth?.disableDashboard ? (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: "16px 20px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                },
              }}
            ></Box>
          ) : null}
        </Box>

        <Box>
          <Button
            sx={{
              background: "#000000",
              minHeight: "auto !important",
              padding: "16px 20px",
              color: "#ffffff",
              fontSize: "16px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
              justifyContent: "center",
              cursor: "pointer",
              width: "100%",
              "& img": {
                marginRight: "15px",
              },
              "&:hover": {
                background: "#000000",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
                justifyContent: "center",
                cursor: "pointer",
                width: "100%",
                "& img": {
                  marginRight: "15px",
                },
              },
              // "& p": {
              //   background: "#000000",
              //   minHeight: "auto !important",
              //   padding: "16px 20px",
              //   color: "#ffffff",
              //   fontSize: "16px",
              //   borderRadius: "8px",
              //   display: "flex",
              //   alignItems: "center",
              //   boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
              //   justifyContent: "center",
              //   cursor: "pointer",
              //   width: "100%",
              //   "& img": {
              //     marginRight: "15px",
              //   },
              // },
            }}
            onClick={(e) => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Confirm Logout",
                  message: "Are you sure, you want to logout?",
                  onOk: () => {
                    dispatch(logoutAction({}));
                    navigate("/login");
                  },
                  okLabel: "Logout",
                  closeLabel: "Stay Logged In",
                }),
              );
            }}
          >
            <img src={LogoutIcon} />
            Logout
            {/* <p
              onClick={(e) => {
                dispatch(logoutAction({}));
              }}
            >
              <img src={LogoutIcon} />
              Logout
            </p> */}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default SidebarContractor;